import { STORAGE_KEYS } from './constants';
import type { DadosContador } from '@/types/auth';

export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEYS.TOKEN);
}

export function getRefreshToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
}

export function getTokenExpiry(): Date | null {
  if (typeof window === 'undefined') return null;
  const expiry = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRY);
  return expiry ? new Date(expiry) : null;
}

export function getDadosContador(): DadosContador | null {
  if (typeof window === 'undefined') return null;
  const data = localStorage.getItem(STORAGE_KEYS.DADOS_CONTADOR);
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

/**
 * Armazena todos os dados de autenticacao no localStorage e configura o cookie de sessao.
 */
export function setAuthData(
  token: string,
  refreshToken: string,
  expiraEmMinutos: number,
  dados: DadosContador
) {
  const expiry = new Date();
  expiry.setMinutes(expiry.getMinutes() + expiraEmMinutos);

  localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  localStorage.setItem(STORAGE_KEYS.TOKEN_EXPIRY, expiry.toISOString());
  localStorage.setItem(STORAGE_KEYS.DADOS_CONTADOR, JSON.stringify(dados));
  localStorage.setItem(STORAGE_KEYS.TIPO_USUARIO, 'contador');

  // Cookie para o middleware de autenticacao do Next.js
  document.cookie = 'contador_session=true; path=/; max-age=86400; SameSite=Lax';
}

/**
 * Remove todos os dados de autenticacao do localStorage e o cookie de sessao.
 */
export function clearAuthData() {
  Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  document.cookie = 'contador_session=; path=/; max-age=0';
}

/**
 * Verifica se o token ira expirar em menos de 5 minutos.
 */
export function isTokenExpiringSoon(): boolean {
  const expiry = getTokenExpiry();
  if (!expiry) return true;
  const fiveMinFromNow = new Date(Date.now() + 5 * 60 * 1000);
  return expiry <= fiveMinFromNow;
}

/**
 * Verifica se o token ja expirou.
 */
export function isTokenExpired(): boolean {
  const expiry = getTokenExpiry();
  if (!expiry) return true;
  return expiry <= new Date();
}

/**
 * Decodifica o payload de um JWT (sem validar a assinatura).
 */
export function parseJwtPayload(token: string): Record<string, any> {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload);
}
